import { render, staticRenderFns } from "./userAgree1.vue?vue&type=template&id=8b4ac3d8&scoped=true&"
import script from "./userAgree1.vue?vue&type=script&lang=js&"
export * from "./userAgree1.vue?vue&type=script&lang=js&"
import style0 from "./userAgree1.vue?vue&type=style&index=0&id=8b4ac3d8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b4ac3d8",
  null
  
)

export default component.exports